import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-receipts-icon',
  templateUrl: './receipts-icon.component.html',
  styleUrls: ['./receipts-icon.component.scss']
})
export class ReceiptsIconComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
